import { makeAutoObservable } from 'mobx'
import WebApp from '@twa-dev/sdk'
import type { WebAppInitData } from '@twa-dev/types'

import { notification } from 'services'
import { ISubscription, Nullable } from 'types'
import { SubscriptionApi } from 'api'

import AuthStore from './AuthStore'

export default class AppStore {
  initData: string
  initDataUnsafe: WebAppInitData
  subscription: Nullable<ISubscription> = null
  auth
  currentOnboardingStep = 0 // 0 для отключения, 1 - 4 - для показа шагов
  totalOnboardingSteps = 4

  constructor() {
    this.initData = WebApp.initData
    this.initDataUnsafe = WebApp.initDataUnsafe
    this.auth = new AuthStore()

    makeAutoObservable(this, undefined, { autoBind: true })

    this.init()
  }

  get initialized() {
    return this.auth.initialized
  }

  openFirstOnboardingTooltip = () => {
    this.currentOnboardingStep = 1
  }

  setNextOnboardingStep = () => {
    this.currentOnboardingStep += 1
  }

  closeOnboarding = () => {
    this.currentOnboardingStep = 0
  };

  *init() {
    if (process.env.NODE_ENV === 'production') {
      yield this.auth.loadToken(this.initData)
    } else {
      yield this.auth.loadTokenInDev(1054011663)
    }
    this.getActiveSubscription()
  }

  *getActiveSubscription() {
    try {
      const { data }: Record<string, any> = yield SubscriptionApi.getActiveSubscription()

      this.subscription = data.data
    } catch {
      notification.error('Ошибка получения данных о подписке')
    }
  }
}
